export default __webpack_public_path__ + "static/media/dateit-22.5265b281.md";